import React, { useEffect, useState } from "react";
import { getPlanLanguages, getPlans } from '../../../slices/plans'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Button } from "../../../components/button";
import { getCurrencies } from "../../../slices/currencies";

const translations = [
    gettext('Plans'),
    gettext('Other plans'),
    gettext('Create plan'),
]

const PlanList = ({ callBack }) => {

    const dispatch = useDispatch()
    const groupedPlans = useSelector((state) => state.plans.groupedResults)
    const navigate = useNavigate();
    let { planId } = useParams();


    useEffect(() => {
        dispatch(getPlans());
        dispatch(getPlanLanguages());
        dispatch(getCurrencies());
    }, [])

    return (
        <div className="container-fluid plans-component">
            <div className="row">
                <div className="col">
                    <h1 className="title">{gettext('Plans')}</h1>
                </div>
            </div>
            <div className="row">
                <ul className="nav flex-column plan-list mb-5">
                    {Object.keys(groupedPlans).length === 1 && Object.keys(groupedPlans)[0] === 'undefined' ?
                        <>

                            {Object.entries(groupedPlans).map(([k, v]) => {
                                return (
                                    <>
                                        {v.map((plan) => {
                                            return (
                                                <li className="nav-item" key={plan.id}>
                                                    <div className={`nav-link ${plan.id == planId ? 'active' : ''}`} onClick={() => { callBack(true), navigate(`/plans/${plan.id}`) }}>
                                                        {plan.name}
                                                    </div>
                                                </li>
                                            )
                                        })}
                                    </>
                                )
                            })}
                        </>
                        :
                        <>
                            {Object.entries(groupedPlans).map(([k, v]) => {
                                return (
                                    <>
                                        <li className="nav-item plan-group" key={k}>
                                            <div className="nav-link">
                                                {k === 'undefined' ? gettext('Other plans') : k}
                                            </div>
                                        </li>
                                        {v.map((plan) => {
                                            return (
                                                <li className="nav-item" key={plan.id}>
                                                    <div className={`nav-link ${plan.id == planId ? 'active' : ''}`} onClick={() => { callBack(true), navigate(`/plans/${plan.id}`) }}>
                                                        {plan.name}
                                                    </div>
                                                </li>
                                            )
                                        })}
                                    </>
                                )
                            })}
                        </>
                    }
                </ul>
                <div className="col px-0">
                    <Button variant={'secondary'} size={'sm'} onClick={() => { callBack(true), navigate('/plans/new') }}>{gettext('Create plan')}</Button>
                </div>
            </div>
        </div>

    )

}

export default PlanList